export default "__VITE_ASSET__BmpkoiG8__"